export default {
    dashboard_gadget_preview: "Vista previa",
    dashboard_gadget_title: "Título",
    dashboard_gadget_frequency_refresh: "Frecuencia de actualización",
    dashboard_gadget_report_type: "Tipo de informe",
    dashboard_gadget_developers: "Desarrolladores",
    dashboard_gadget_chart_type: "Tipo de gráfico",
    dashboard_gadget_time_metric: "Métrica del tiempo",

    dashboard_gadget_five_minutes: "5 Minutos",
    dashboard_gadget_fifteen_minutes: "15 Minutos",
    dashboard_gadget_thirty_minutes: "30 Minutos",
    dashboard_gadget_one_hour: "1 Hora",
    dashboard_gadget_two_hour: "2 Horas",
    dashboard_gadget_this_month: "Este mes",
    dashboard_gadget_last_month: "El mes pasado",
    dashboard_gadget_this_quarter: "Este cuarto",
    dashboard_gadget_last_quarter: "Último cuarto",
    dashboard_gadget_this_year: "Este año",
    dashboard_gadget_last_year: "El año pasado",

    dashboard_gadget_column: "Columna",
    dashboard_gadget_line: "Línea",

    dashboard_gadget_all_developers: "Todos los desarrolladores",
    dashboard_gadget_developers_metrics: "Métricas de desarrollador",
    dashboard_gadget_developer: "Desarrollador",
    dashboard_gadget_example: "Ejemplo",
    dashboard_gadget_today: "Hoy",
    dashboard_gadget_yesterday: "Ayer",
    dashboard_gadget_thisweek: "Esta semana",
    dashboard_gadget_lastweek: "Semana pasada",
    dashboard_gadget_last7days: "Últimos 7 días",
    dashboard_gadget_last15days: "Últimos 15 días",
    dashboard_gadget_last30days: "Últimos 30 días",
    dashboard_gadget_custom: "Personalizado",
    dashboard_gadget_age: "Edad (Días)",
    dashboard_gadget_account_status: "Estado de la cuenta",
    dashboard_gadget_device_status: "Estado del dispositivo",

    dashboard_gadget_min_length_message: "La edad debe contener un mínimo de caracteres:",
    dashboard_gadget_max_length_message: "La edad debe contener un máximo de caracteres:",
    dashboard_gadget_define_maximum: "Definir el valor máximo período de días para evaluar que están informando",
    dashboard_gadget_define_initial_value: "Definir el valor inicial de los días no reportados",
    dashboard_gadget_define_interval_value: "Defina el intervalo en días para generar el gráfico",
    dashboard_gadget_define_interval: "Intervalo",
    dashboard_gadget_imei: "IMEI o Serial",
}